// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://lsbmvfjymydutatevugb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxzYm12Zmp5bXlkdXRhdGV2dWdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwNTY3ODAsImV4cCI6MjA1ODYzMjc4MH0.wE7EET3jD-z4uwLpo-YBfeY1EsUljX5R_gW2n4Beyo0";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);